import React from 'react';

import EmptyMessageCard from '../../../../scout/components/message-card/EmptyMessageCard';
import MessageCard from './MessageCard';

import scss from './MessagesList.module.scss';

function MessagesList({ content }) {
  return (
    <div className={scss.listWrapper}>
      {content.map((message) => (
        <MessageCard key={message.count} message={message} />
      ))}

      {content.length === 0 ? <EmptyMessageCard /> : null}
    </div>
  );
}

export default MessagesList;
